module.exports = __webpack_public_path__ + "img/logo.6ec5c525.svg";